import { actionTypes } from './constants';
import { getSessionCurrency, getLocalCurrency } from '../utils/preferredCurrency';

const headerActionCreators = {
    setUpdateUserState: updateUserState => {
        return { type: actionTypes.SET_UPDATE_USER_STATE, updateUserState };
    },
    setUserTypeTrade: isUserTypeTrade => {
        return { type: actionTypes.SET_USER_TYPE_TRADE, isUserTypeTrade };
    },
    setUserTypeVip: isUserTypeVip => {
        return { type: actionTypes.SET_USER_TYPE_VIP, isUserTypeVip };
    },
    setInitialTrackingFired: () => {
        return { type: actionTypes.INITIAL_TRACKING_FIRED };
    },
    resetTrackingFired: () => {
        return { type: actionTypes.RESET_TRACKING_FIRED };
    },
    setBannerMessages: bannerMessages => {
        return { type: actionTypes.SET_BANNER_MESSAGES, bannerMessages };
    },
    toggleMobileMenu: isMobileMenuOpen => {
        return { type: actionTypes.TOGGLE_MOBILE_MENU, isMobileMenuOpen };
    },
};

const currencyActionCreators = {
    populateCurrency: currency => {
        const sessionCurrency = getSessionCurrency();
        const localCurrency = getLocalCurrency();
        return {
            type: actionTypes.POPULATE_CURRENCY,
            payload: { sessionCurrency, localCurrency, currency },
        };
    },
};

const actionCreators = {
    ...headerActionCreators,
    ...currencyActionCreators,
};

export { actionCreators };
export default { actionCreators };
